<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--client-invoice dashboard-widget--client-invoice-log">
        <div class="card-header">
                <h6 class="fw-bold mb-0 dashboard-widget__title">
                    <span class="dashboard-widget__icon" v-html="sidebarSvg.clientInvoice"></span>
                    <span>{{ $t('Client Invoices') }}</span>
                </h6>
        </div>
        <div class="card-body p-0">
            <div
                class="client-invoice-list__table-scroll"
                role="region"
                aria-label="Client invoices"
                tabindex="0"
            >
              <table class="table table-striped">
                <thead>
                    <tr>
                        <th>{{ $t('S/N') }}</th>
                        <th>{{ $t('Invoice No.') }}</th>
                        <th>{{ $t('Date') }}</th>
                        <th class="text-end">{{ $t('Submitted Amount') }}</th>
                        <th>{{ $t('Status')}}</th> 
                        <th class="text-end">{{ $t('Amount') }} {{ $t('Paid') }}</th>
                        <th class="dashboard-widget-table__actions">{{ $t('Actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data.length==0">
                        <td colspan="7" class="text-center dashboard-widget__empty-state">{{ $t('No data Found') }}</td>
                    </tr>
                    <tr v-for="(item,key) in data" :key="key">
                        <td>{{ key + 1 }}</td>
                        <td><a :href="dotNetUrl + '/clientinvoice/item/' + item.id" class="link-style-custom">{{ item.invoiceNumber || 'SINXXXX' }}</a></td>
                        <td>{{ ReformatDate(item.invoiceDate) }}</td>
                        <td  class="text-end">{{projectInfo.currencyId?.sign}}{{ ReformatNumber(item.amount) }}</td>
                        <td> <span :class="color[item.status - 1]">{{ item.statusName }}</span> </td>
                        <td  class="text-end">
                            <span v-if="item.status==7">{{projectInfo.currencyId?.sign}}{{ ReformatNumber(item.amount) }}</span>
                            <span v-else>-</span>
                        </td>
                        <td class="dashboard-widget-table__actions">
                            <a :href="dotNetUrl + '/clientinvoice/item/' + item.id" :title="$t('View')" :aria-label="$t('View')">
                                <i class="fa-regular fa-eye" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
            <div class="dashboard-widget__footer dashboard-widget__footer--end"> <a  :href="dotNetUrl + '/clientinvoice/' + projectInfo.projectOldId" class="dashboard-widget__link">{{ $t('View All') }}</a></div>
        </div>
    </div>
</template>

<script>
import {DashboardGetProjectClientInvoice} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import 'dotenv/config'
export default {
    name : 'ClientInvoiceList',
    props : ['projectInfo'],
    data(){
        return {
            data : [],
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            color : ['text-muted','text-primary','text-warning','text-success','text-primary','text-success','text-success'],
            sidebarSvg
        }
    },
    mounted : async function(){
        const self = this
        const response = await DashboardGetProjectClientInvoice(self.projectInfo._id)
        if(!response)
            return
        self.data = response.data
    },
    methods :{
        ReformatNumber,ReformatDate
    }
    
} 
</script>

<style scoped>
.client-invoice-list__table-scroll {
    width: 100%;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-color: #7f9fca #edf3fa;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
}

.client-invoice-list__table-scroll:focus-visible {
    outline: 2px solid #004aad;
    outline-offset: 2px;
}

.client-invoice-list__table-scroll .table {
    min-width: 48rem;
    margin-bottom: 0;
}
</style>
